/**
 * game-api-serverless wrappers for persona-based RPS play.
 * HMAC is signed by the BFF at /proxy/game.
 */

import { dmRequest } from './dmApiClient';

export const GAME_PROXY = '/proxy/game';
const API_PREFIX = '/api/v0/game/rps';

export const RPS_CHOICE = {
  ROCK: 1,
  PAPER: 2,
  SCISSORS: 3,
};

export const RPS_STATUS = {
  PENDING: 0,
  COMPLETED: 1,
  DRAW: 2,
};

function unwrap(res) {
  return res?.data ?? null;
}

export async function postRpsChallenge(accessToken, { opponentUserId, choice }) {
  const res = await dmRequest(GAME_PROXY, `${API_PREFIX}/challenge`, {
    method: 'POST',
    accessToken,
    body: { opponent_user_id: Number(opponentUserId), choice: Number(choice) },
  });
  return unwrap(res);
}

export async function postRpsRespond(accessToken, { matchId, choice }) {
  const res = await dmRequest(GAME_PROXY, `${API_PREFIX}/respond`, {
    method: 'POST',
    accessToken,
    body: { match_id: Number(matchId), choice: Number(choice) },
  });
  return unwrap(res);
}

export async function postRpsRematch(accessToken, { matchId, choice }) {
  const res = await dmRequest(GAME_PROXY, `${API_PREFIX}/rematch`, {
    method: 'POST',
    accessToken,
    body: { match_id: Number(matchId), choice: Number(choice) },
  });
  return unwrap(res);
}

export async function getRpsInbox(accessToken, { cursor, limit = 20 } = {}) {
  const res = await dmRequest(GAME_PROXY, `${API_PREFIX}/matches/inbox`, {
    method: 'GET',
    accessToken,
    query: { cursor, limit },
  });
  return unwrap(res) || [];
}

export async function getRpsHistory(accessToken, { cursor, limit = 20 } = {}) {
  const res = await dmRequest(GAME_PROXY, `${API_PREFIX}/matches/history`, {
    method: 'GET',
    accessToken,
    query: { cursor, limit },
  });
  return unwrap(res) || [];
}

export async function getRpsStats(accessToken, userId) {
  const res = await dmRequest(GAME_PROXY, `${API_PREFIX}/stats/${userId}`, {
    method: 'GET',
    accessToken,
  });
  return unwrap(res);
}
